import { onMounted } from 'vue';

import JssFormsEventBus from '@/jss-forms/jss-forms-event-bus';

export interface DataFormElementKeyProps {
  dataFormElementKey?: string;
  dataFormItemId?: string;
}

export default (props: DataFormElementKeyProps) => {
  onMounted(() => {
    if (props.dataFormElementKey) {
      JssFormsEventBus.$emit('forms_init:field-conditions', props.dataFormElementKey);
    }
  });
};
